<template>
  <div id="container">
    <div id="LoginBox" v-loading="loading">
      <div class="login_logo">
        <a href="/" class="logo"></a>
        <h1 class="line_h1">{{$t('base.welcome')}}</h1>
      </div>
      <div class="login_tab">
        <div :class="{'on':ruleForm.Type=='1'}" @click="ruleForm.Type='1'">{{$t('base.phoneNumber')}}</div>
        <div :class="{'on':ruleForm.Type=='0'}" @click="ruleForm.Type='0'">{{$t('base.email')}}</div>
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item class="login_form_item" prop="Account">

          <!-- 国籍 -->
          <div class="locationPhoneBox login_location" v-if="ruleForm.Type=='1'">
            <div class="countries" v-if="location.MemberSource!=''">
              <img :src="location.LocationIcon" alt="">
            </div>
            <el-select class="login_ipt" :class="location.MemberSource!=''?'nolocation':''" placeholder="" v-model="location.MemberSource" popper-class='location' @change='changeLocation'>
              <el-option class="locationelOption" :label="item.EnName" :value="item.Code" v-for="(item,index) in locationOption" :key='index'>
                <div class="locationOption">
                  <img :src="item.IconUrl">
                  <span>{{item.EnName}}</span>
                </div>
              </el-option>
            </el-select>
            <div class="nationCode">
              {{location.AreaCode}}
            </div>
          </div>
          <!-- 手机号和邮箱 -->
          <el-input class="login_ipt first_login_ipt" :class="{'email':ruleForm.Type=='1'}" v-model="ruleForm.Account" :placeholder="ruleForm.Type=='1'?$t('base.phoneNumber'):$t('base.email')" autocomplete="off" @input='emailInput' ></el-input>
          <!-- <el-input class="login_ipt first_login_ipt" v-model="ruleForm.Account" placeholder="Email" @input='emailInput' v-if="ruleForm.Type=='0'"></el-input> -->
        </el-form-item>
        <el-form-item class="login_form_item" prop="Password">
          <el-input class="login_ipt" :type="flagType" v-model="ruleForm.Password" :placeholder="$t('base.password')" @input="search" autocomplete="off">
              <i slot="suffix" class="showing" :class="[flag == true?'show':'noshow']" v-show="ifshow" @click="getFlag()" />
          </el-input>
        </el-form-item>
        <div class="forgot">
          <span class="text_blue" @click="goto('ruleForm')">{{$t('symbol.forgotPwd')}}</span>
        </div>
        <el-button class="text_btn" :disabled="disabled" type="primary" @click="submitForm('ruleForm')">{{$t('base.logIn')}}</el-button>
      </el-form>
      <div class="terms_checked">
        <!-- <el-checkbox v-model="checked"></el-checkbox> -->
        <el-checkbox  v-model="checkbox " :label="1">{{radioNumber}}</el-checkbox >
        <div>
          {{$t('base.agreeTo')}} <router-link class="text_blue" :to="{path:'/terms/privacy?type=2'}" target="_blank">{{$t('base.service')}}</router-link> {{$t('base.and')}} <router-link class="text_blue" :to="{path:'/terms/privacy?type=1'}" target="_blank">{{$t('base.privacy')}}</router-link>
        </div>
      </div>
      <div class="account_box">
        {{$t('symbol.noAccount')}} <router-link class="text_blue" :to="{path:'/register'}">{{$t('base.signUp')}}</router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { CensoredEmail, getUser } from "@/api/public";
export default {
  name: 'index',
  components: {},
  data() {
    var userValidate = (rule, value, callback) => {
      if (value === '') {
        if(this.ruleForm.Type=='1'){
          callback(new Error(this.$t('rules.invalidPhone')));
        }
        callback(new Error(this.$t('rules.emailRule')));
      } else if (value != '') {
        if(this.ruleForm.Type=='0'){
          let reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
          if (reg.test(value)) {
            callback();
          }else{
            callback(new Error(this.$t('rules.emailRule')));
          }
          
        }
        callback();
      } else if (this.smsMsg) {
        callback(new Error(this.smsMsg));
      } else {
        callback();
      }
    };
    var passValidate = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('rules.emailPwdIncorrect')));
      } else if (this.psMsg) {
        callback(new Error(this.psMsg));
      } else {
        callback();
      }
    };
    return {
      flagType: 'password',
      flag: false,
      loading: false,
      psMsg: '',
      smsMsg: '',
      disabled: false,
      // checked:false,
      radioNumber: '',
      checkbox : false,
      ifshow: false,
      locationOption:'',
      location:{
        MemberSource:'',
        LocationIcon:'',
        LocationName:'',
        AreaCode:''
      },
      ruleForm: {
        Account:'',//邮箱或手机
        Password:'',//密码
        Type:'1',//登录类型 0邮箱 1手机号
        AreaCode:''//手机区号
      },
      rules: {
        Account: [
          { validator: userValidate, trigger: 'blur'},
          //{ type: 'email', message: 'Enter the email address like this: name@email.com', trigger: 'blur' },
        ],
        Password: [
          { validator: passValidate }
        ]
      },
    }
  },
  created() {
    this.getNationIcons()
  },
  mounted() {
    let that=this
    window.addEventListener('keydown', function(e) {
      if(e.keyCode===13){
        that.submitForm('ruleForm')
      }
    })
    //console.log(this.$interface.SignIn)
  },
  beforeDestroy() {
    window.removeEventListener('message', function(e) {});
  },
  methods: {
    // 修改国家
    changeLocation(e) {
      let that = this
      that.locationOption.map(res => {
        if (res.Code == e) {
          that.location.MemberSource = res.Code //
          that.location.LocationIcon = res.IconUrl
          that.location.LocationName = res.EnName
          that.location.AreaCode = res.NationCode
          that.ruleForm.AreaCode = res.NationCode
        }
      })
      console.log(that.ruleForm)
    },
    //获取全部国家图标地址
    getNationIcons() {
      let that = this
      this.$get(this.$interface.GetAllNationIcons, '').then(res => {
        if (res.Result != 0) {
          that.locationOption = res.Data
          that.location.MemberSource = res.Data[0].Code //
          that.location.LocationIcon = res.Data[0].IconUrl
          that.location.LocationName = res.Data[0].EnName
          that.location.AreaCode = res.Data[0].NationCode
          that.ruleForm.AreaCode = res.Data[0].NationCode
        }
      })
    },
    //是否显示查看密码的图标
    search(){
      if(this.ruleForm.Password.length>0){
        this.ifshow = true
      }else{
        this.ifshow = false
      }
    },
    //密码切换状态
    getFlag() {
      this.flag = !this.flag
      this.flagType = this.flag ? 'text' : 'password'//text为显示密码；password为隐藏密码
      console.log(this.flag,this.flagType)
    },
    // 删除email清空密码
    emailInput(){
      if(this.ruleForm.Account.length<1){
        this.ruleForm.Password=''
      }
    },
    // 有邮箱跳转忘记密码
    goto(formName) {
      let that = this;
      let query={account: that.ruleForm.Account,type: that.ruleForm.Type}
      if(that.ruleForm.Type=='1'){
        query.source=that.location.MemberSource
      }
      this.$router.push({
        path: '/forgot',
        query: query
      })
      // that.smsMsg = ""
      // that.$refs[formName].validateField("email", (val) => {
      //   if (val == "") {
      //     this.$router.push({
      //       path: '/forgot',
      //       query: {
      //         email: that.ruleForm.email
      //       }
      //     })
      //   }
      // })
    },
    // 登入
    submitForm(formName) {
      let that = this;
      that.psMsg = "", that.smsMsg = ""
      this.$refs[formName].validate((valid) => {
        if (valid) {
          var data = that.ruleForm
          if(that.ruleForm.Type!='1'){
            data.AreaCode='+86'
          }
          if (this.checkbox  == false) {
            this.$confirm(`<div style="padding: 0 24px;">`+that.$t('alert.toProceed')+` <a href="#/terms/privacy?type=2"  target="_blank" class="text_blue">`+that.$t('base.service')+`</a> `+that.$t('base.and')+` <a href="#/terms/privacy?type=1"  target="_blank" class="text_blue">`+that.$t('base.privacy')+`</a>.</div>`, that.$t('base.notice'), { 
              // showConfirmButton: true ,
              customClass: "NoticeBox",
              dangerouslyUseHTMLString: true,
              confirmButtonText: that.$t('base.agree'),
              cancelButtonText: that.$t('base.cancel'),
              }).then(() => {
                this.checkbox = true;
                this.submitForm('ruleForm');
              })
              .catch(() => {
                
              });
          } else {
            this.disabled = true;
            that.loading = true;
            this.$post(this.$interface.SignIn, data).then(res => {
              console.log(res.Data)
              if (res.Result != 0) {
                this.$message({
                  type: 'success',
                  duration: 1000,
                  message: 'Login successful!'
                });
                if(res.Data.EMail||res.Data.Email){
                  res.Data.Email = CensoredEmail(res.Data.EMail||res.Data.Email)
                }
                getUser(res.Data)
              } else {
                if (res.Msg.toLowerCase().indexOf('password') != -1) {
                  that.psMsg = res.Msg
                  that.$refs[formName].validateField("Password");
                } else {
                  that.smsMsg = res.Msg
                  that.$refs[formName].validateField("Account");
                }
                this.$message({
                  type: 'error',
                  duration: 2000,
                  message: res.Msg
                });
                that.loading = false;
                //that.$refs[formName].validateField("email");
                that.disabled = false;
              }
            }).catch(error => {
              that.loading = false;
              that.disabled = false;
            })
          }
        }
      });
    }
  }
}

</script>
<style scoped>
@import "../../../static/css/login.css";
/* /deep/.login_ipt .el-input__suffix{
  margin: 14px 10px 0 0;
} */
/deep/ .el-checkbox__inner{
  border-color: #a0a0a0;
}
</style>



// WEBPACK FOOTER //
// src/pages/shared/login.vue